import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../../../app/core/services/auth.service';
import { GlobalName } from '../../../../../../app/core/utils/global-name';
import { LocalStorageService } from '../../../../../../app/core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../shared/loading/loading.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone:true,
  imports:[
     CommonModule,
        FormsModule,
        NgbModule,
        NgxPaginationModule,
        LoadingComponent,
        SampleSearchPipe
  ]
})
export class LoginComponent implements OnInit {

  loading=false
 
  constructor(
    private authService:AuthService,
    private lsService:LocalStorageService,
    private router: Router,
    private toastr: ToastrService
    ) { }

  ngOnInit(): void {
  }


  login(value:any){
    this.loading=true
    this.authService.login(value).subscribe((res:any)=>{
      this.loading=false

      this.lsService.set(GlobalName.tokenName,res.data?.access_token)
      this.lsService.set(GlobalName.refreshTokenName,res.data?.refresh_token)
      this.lsService.set(GlobalName.expireIn,res.data?.expire_in);
      this.lsService.set(GlobalName.features,res.data?.features);
     this.authService.me().subscribe((res:any)=>{
      this.lsService.set(GlobalName.userName,res.data);
      this.router.navigate(['/dashboard'])
      this.toastr.success('Connexion réussie', 'Connexion');
     })
     
    },
    (err:any)=>{
      console.log(err)
      this.loading=false
      this.toastr.error(err.error?.message, 'Connexion');

    });
  }

}
